$(".owl-carousel.quote").owlCarousel({
    items: 1,
    autoplay: true,
    loop: true,
    nav: true,
    dots: true,
});


$(".owl-carousel.product-carousel").owlCarousel({
    items: 1,
    nav: true,
    dots: true,
});
$(".owl-carousel.banner").owlCarousel({
    items: 1,
    nav: false,
    dots: false,
    loop: true,
    mouseDrag: true,
    autoplay: true,
    autoplaySpeed: 1500,
    autoplayTimeout: 4000,
    responsive: {

        // breakpoint from 768 up
        768: {
            items: 2,
            mouseDrag: false,
            loop: false,
            autoplay: false,

        }
    }
});




$('.category-product select').change(function(e) {
    let imgUrl = $(this).find('option:selected').data('img');
    $(this).closest('.category-product').find('img').attr('src', imgUrl);

})

$('#product-variant-select').change(function(e) {
    var position = $(this).find('option:selected').data('position');
    $('.owl-carousel.product-carousel').trigger('to.owl.carousel', position - 1)
})



$('form[action="/cart/add"]').submit(function(e) {
    let $values = $(this).serializeArray();

    let index = $values.findIndex(p => p.name == "id")
    let id = $values[index].value

    if (!id) {
        alert('Please select an option')
        return false;
    }
})

$('#back-to-login-link').click(function(e) {
    e.preventDefault();

    $('#forgot-password-form').hide();
    $('#login-form').show();

});

$('#forgot-password-link').click(function(e) {
    e.preventDefault();

    $('#forgot-password-form').show();
    $('#login-form').hide();

});


$('.address-edit').click(function(e) {
    e.preventDefault();


    $('.edit-address-form').each(function() {
        $(this).hide();
    });

    let addressId = $(this).data('addressid');
    $('#EditAddress_' + addressId).show();
})


$('.address-delete').click(function() {
    if (confirm('Are you sure you want to delete this address?')) {
        $(this).closest('form.address-delete-form').submit();
    }
});


$('.cancel-address-button').click(function(e) {
    e.preventDefault();

    $(this).closest('.edit-address-form').hide();

});


$('.new-address-button').click(function(e) {

    e.preventDefault();

    $('#new-address-form').show();

});


$('#suppliers-nav a').click(function(e) {

    e.preventDefault();

    $this = $(this);
    $supplierId = $this.data('supplierid');

    $('#suppliers-nav a').each(function() {
        $(this).removeClass('active');
    });

    $this.addClass('active');

    $('#suppliers-content [data-supplierid]').each(function() {

        if ($(this).data('supplierid') == $supplierId) {
            $(this).show();
        } else {
            $(this).hide();
        }

    });
})


$('.cancel-address-button').click(function(e) {
    e.preventDefault();
    $(this).closest('.edit-address-form').hide();
});


$('.new-address-button').click(function(e) {
    e.preventDefault();
    $('#new-address-form').show();

});



$('#suppliers-nav a').click(function(e) {

    e.preventDefault();

    $this = $(this);
    $supplierId = $this.data('supplierid');

    $('#suppliers-nav a').each(function() {
        $(this).removeClass('active');
    });

    $this.addClass('active');

    $('#suppliers-content [data-supplierid]').each(function() {

        if ($(this).data('supplierid') == $supplierId) {
            $(this).show();
        } else {
            $(this).hide();
        }

    });

})

$(function() {
    var newsletterSignUp = getParameterByName('customer_posted');

    if (newsletterSignUp == 'true') {
        $('.newsletter-footer').get(0).scrollIntoView();
    }
})


function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Sub menu
var hideSubMenu = function() {
    $('[id^=child-menu-]').hide();
}

$('.nav-item-children[data-target^=child-menu-]').mouseenter(function() {
    hideSubMenu();
    var targetId = $(this).data('target');
    var target = $('#' + targetId);

    target.css('display', 'flex');

    $(this).on("mouseleave", function() {
        hideSubMenu();
    })

})

document.addEventListener('lazybeforeunveil', function(e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});